<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Create Invoice {{$route.meta.type_invoice=="0" ? "Account Pay" : "Addendum"}}</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Detail" />
    </a-steps>
    <div class="steps-content flex-1">
      <keep-alive>
        <component
          class="flex-1"
          :is="steps[current].content"
          :ref="stepRef"
          v-bind="stepProps"
        ></component>
      </keep-alive>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          :loading="btnLoading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >Save</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Informasi from "./steps/Informasi.vue";
import Detail_AP from "./steps/Detail_AP.vue";
import Detail_AD from "./steps/Detail_AD.vue";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "CreateInvoice",
  props: ["id", "type"],
  mixins: [CurrencyFormat,GlobalMethod],
  components: {
    Informasi,
    Detail_AP,
    Detail_AD,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Detail",
          content: this.$route.meta.type_invoice=="0" ? "Detail_AP" : "Detail_AD",
        },
      ],
      mode: "Create",
      collectData: {
        informasi: [],
        listData: [],
      },
      templistData: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      btnLoading: false,
      files: [],
      po_wo_dtl:[],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate"]),
    // initialListItem() {
    //   console.log("initialListItem")
    //   let data = [];
    //   let hargaTotal = 0;
    //   // if (this.mode === "Edit") {
    //   //   this.listPembelian.forEach(item => {
    //   //     hargaTotal = item.values.jumlah * item.values.harga;
    //   //     const values = item.values;
    //   //     data = [...data, { hargaTotal: hargaTotal, values }];
    //   //   });
    //   // } else {
    //     if(this.collectData.listData.length>0)
    //     this.collectData.listData.forEach(item => {
    //       hargaTotal = item.jumlah * item.harga;
    //       data = [
    //         ...data,
    //         {
    //           hargaTotal: hargaTotal,
    //           values: item
    //         }
    //       ];
    //     });
    //   // }
    //   return data;
    // },
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            id: this.id,
            jenis_transaksi: this.type,
            data: this.collectData.informasi,
            listData: this.collectData.listData,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === (this.$route.meta.type_invoice=="0" ? "Detail_AP" : "Detail_AD")) {
          return {
            // listData: this.templistData,
            // // keuangan: this.keuangan,
            // informasi: this.collectData.informasi,
            // mata_uang: this.collectData.informasi.mata_uang,
            // // shipping : this.collectData.informasi.shipping,
            // // check_shipping : this.collectData.informasi.check_shipping,
            // // tax: this.collectData.informasi.tax,
            // // mode: "Edit",
            // // mata_uang: this.collectData.selectedPP[0] ? this.collectData.selectedPP[0].currency : null,
            // // id_pp: this.collectData.informasi.id_pp,
            // po_wo_dtl: this.po_wo_dtl
            listData: this.collectData.listData,
            // keuangan: this.keuangan,
            informasi: this.collectData.informasi,
            mata_uang: this.collectData.informasi.mata_uang,
            po_wo_dtl: this.po_wo_dtl,
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            id: this.id,
            jenis_transaksi: this.type,
            data: this.collectData.informasi,
            mode: this.mode,
            listData: this.templistData,
          };
        } else if (this.steps[this.current].content === (this.$route.meta.type_invoice=="0" ? "Detail_AP" : "Detail_AD")) {
          return {
            listData: this.templistData,
            // keuangan: this.keuangan,
            informasi: this.collectData.informasi,
            mata_uang: this.collectData.informasi.mata_uang,
            po_wo_dtl: this.po_wo_dtl,
          };
        }
      }
      return true;
    },
    stepRef: function () {
      let val = "";
      if (this.steps[this.current].content === "Informasi") {
        val = "refInformasi";
      } else if (this.steps[this.current].content === (this.$route.meta.type_invoice=="0" ? "Detail_AP" : "Detail_AD")) {
        val = "refDetail";
      }
      return val;
    },
  },
  created() {
    if (this.$route.name =="invoice-edit-ap" || this.$route.name =="invoice-edit-ad"){
      this.mode = "Edit";
    }
  },
  methods: {
    moment,
    next() {
      //console.log(this.steps[this.current].content)
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === (this.$route.meta.type_invoice=="0" ? "Detail_AP" : "Detail_AD")) {
        this.$refs.refDetail.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refDetail.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value.informasi;
        this.files = [];
        this.files.push(value.informasi.fileList[0]);

        if(value.dtlForEdit){
          this.collectData.listData = value.dtlForEdit;
        }
        this.current++;
      } else if (this.steps[this.current].content === this.$route.meta.type_invoice=="0" ? "Detail_AP" : "Detail_AD") {
        this.collectData.listData = value.listData;
        this.collectData.emptyValidator = value.emptyValidator;
        this.collectData.total = value.total;

        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    valueEdit(value){
        this.collectData.informasi = value.informasi;
        this.files = [];
        this.files.push(value.informasi.fileList.file);

        if(value.dtlForEdit){
          this.collectData.listData = value.dtlForEdit;
        }
    },
    getUpdateList(item) {
      //this.templistData = [...this.templistData, JSON.parse(JSON.stringify(item.value))];
      let val = [];
      if (this.collectData.listData.length > 0) {
        if (item.type == "update") {
          val = this.collectData.listData;
        }
      }
      //val.push(this.collectData.listData)
      if (item.value && item.type == "update") {
        val.push(item.value);
      } else if (item.value && item.type == "delete") {
        val = item.value;
      }
      //console.log("val",val)
      this.collectData.listData = val;
      this.templistData = val;
      //console.log("getUpdateList",this.collectData.listData)
    },
    setSubmitForm() {
      //console.log("simpan")
      if (this.mode === "Edit") {
        this.postData = new FormData();
        this.postData.append("id_invoice_ap_ad", this.id);
        this.postData.append("tlc", this.getAuth.username);
        this.postData.append("type_of_transaction",this.collectData.informasi.jns_transaksi);
        this.postData.append("no_po_wo",this.collectData.informasi.no_po_wo);
        this.postData.append("id_supplier", this.collectData.informasi.id_supplier);
        this.postData.append("bank_name", this.collectData.informasi.name_bank);
        this.postData.append("account_bank_number", this.collectData.informasi.account_bank);
        this.postData.append("no_invoice", this.collectData.informasi.no_invoice);
        this.postData.append("no_invoice_receive",
          this.collectData.informasi.no_invoice_receive ? this.collectData.informasi.no_invoice_receive : "");
        this.postData.append("no_faktur", this.collectData.informasi.no_faktur);
        this.postData.append("no_tracking", 
          this.collectData.informasi.no_tracking ? this.collectData.informasi.no_tracking : "");
        this.postData.append("date_of_invoice",
          moment(this.collectData.informasi.date_invoice).format(this.getStandartFormatDate));
        this.postData.append("due_date",
          moment(this.collectData.informasi.duedate).format(this.getStandartFormatDate));
        this.postData.append("description", this.collectData.informasi.description);
        this.postData.append("note", this.collectData.informasi.note);
        this.postData.append("value_invoice", this.collectData.total*this.collectData.informasi.kurs);
        this.postData.append("value_invoice_label", this.collectData.total);
        this.postData.append("file_document", this.files[0]);
        this.postData.append("type_invoice", this.$route.meta.type_invoice);
        this.postData.append("pib", this.collectData.informasi.pib?"1":"0");
        if(this.collectData.informasi.user_cc)
          this.postData.append("user_cc", this.collectData.informasi.user_cc);

        this.collectData.listData.forEach((data, index) => {
          this.postData.append(`id_dtl[${index}]`, data.used_for ? data.id_dtl : "");
          this.postData.append(`used_for[${index}]`, data.used_for ? data.used_for : "");
          this.postData.append(`po_wo_dtl[${index}]`, data.po_wo_id ? data.po_wo_id : "");
          this.postData.append(`item_name[${index}]`, data.nama_item? data.nama_item: "");
          this.postData.append(`quantity[${index}]`, data.quantity? data.quantity : "");
          this.postData.append(`value_label[${index}]`, data.value_label ? data.value_label: "");
          this.postData.append(`value[${index}]`, data.value ? data.value: "");
          this.postData.append(`type_tax[${index}]`, data.type_tax ? data.type_tax: "");
          this.postData.append(`unit[${index}]`, data.unit ? data.unit: "");
          this.postData.append(`catatan[${index}]`, data.note ? data.note: "");
        });
      } else {
        this.postData = new FormData();
        this.postData.append("tlc", this.getAuth.username);
        this.postData.append("type_of_transaction",this.collectData.informasi.jns_transaksi);
        this.postData.append("no_po_wo",this.collectData.informasi.no_po_wo);
        this.postData.append("id_supplier", this.collectData.informasi.id_supplier);
        this.postData.append("bank_name", this.collectData.informasi.name_bank);
        this.postData.append("account_bank_number", this.collectData.informasi.account_bank);
        this.postData.append("no_invoice", this.collectData.informasi.no_invoice);
        this.postData.append("no_invoice_receive",
          this.collectData.informasi.no_invoice_receive ? this.collectData.informasi.no_invoice_receive : "");
        this.postData.append("no_faktur", this.collectData.informasi.no_faktur);
        this.postData.append("no_tracking", 
          this.collectData.informasi.no_tracking ? this.collectData.informasi.no_tracking : "");
        this.postData.append("date_of_invoice",
          moment(this.collectData.informasi.date_invoice).format(this.getStandartFormatDate));
        this.postData.append("due_date",
          moment(this.collectData.informasi.duedate).format(this.getStandartFormatDate));
        this.postData.append("description", this.collectData.informasi.description);
        this.postData.append("note", this.collectData.informasi.note);
        this.postData.append("value_invoice", this.collectData.total*this.collectData.informasi.kurs);
        this.postData.append("value_invoice_label", this.collectData.total);
        this.postData.append("file_document", this.files[0]);
        this.postData.append("type_invoice", this.$route.meta.type_invoice);
        this.postData.append("pib", this.collectData.informasi.pib?"1":"0");
        if(this.collectData.informasi.user_cc)
          this.postData.append("user_cc", this.collectData.informasi.user_cc);

        this.collectData.listData.forEach((data, index) => {
          this.postData.append(`used_for[${index}]`, data.used_for ? data.used_for : "");
          this.postData.append(`po_wo_dtl[${index}]`, data.po_wo_id ? data.po_wo_id : "");
          this.postData.append(`item_name[${index}]`, data.nama_item? data.nama_item: "");
          this.postData.append(`quantity[${index}]`, data.quantity? data.quantity : "");
          this.postData.append(`value_label[${index}]`, data.value_label ? data.value_label: "");
          this.postData.append(`value[${index}]`, data.value ? data.value: "");
          this.postData.append(`type_tax[${index}]`, data.type_tax ? data.type_tax: "");
          this.postData.append(`unit[${index}]`, data.unit ? data.unit: "");
          this.postData.append(`catatan[${index}]`, data.note ? data.note: "");
        });
      }
    },
    submit() {
      if (this.collectData.emptyValidator == 0) {
        this.displayMessage("empty-invoiceList");
        return;
      } else {
        let lst = this.collectData.listData.filter((item, index) => {
          if (item.value <= 0) return item;
        });
        if (lst.length > 0) {
          this.displayMessage("empty-invoiceList");
          return;
        }
      }

      this.setSubmitForm();
      this.btnLoading = true;
      let data = "";
      let url = "";
      if (this.mode === "Create") {
        data = this.postData;
        url = "invoice/submit";
      } else {
        data = this.postData;
        url = "invoice/edit";
      }

      this.asyncAxiosPost(url, "formdata", this.getAuth, data)
      .then(() => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
          }
          this.btnLoading = false;
          this.current = 0;
          this.$router.push({ name: "invoice-index" });
        })
        .catch((err) => {
          this.btnLoading = false;
          let response = Object.assign({}, err.response);
          if (response.data.message.includes("Saldo PP tidak cukup")) {
            let sisa = this.formatCurrency(
              this.collectData.selectedPP[0].currency,
              response.data.message.replace("Saldo PP tidak cukup!", "")
            );
            this.displayMessageValue("pp-notenough", sisa);
          } else if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            //console.log(responses);
            this.displayMessageValue("error", responses);
          }
        });
    },
    getUpdatePoWoList(value){
      this.po_wo_dtl = value.value;
    },
  },
  mounted() {
    Event.$on("invData", this.valueFromChild);
    Event.$on("invDataEdit", this.valueEdit);
    Event.$on("updateList", this.getUpdateList);
    Event.$on("updatepowodtl", this.getUpdatePoWoList);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("invData", this.valueFromChild);
    Event.$off("invDataEdit", this.valueEdit);
    Event.$off("updateList", this.getUpdateList);
    Event.$off("updatepowodtl", this.getUpdatePoWoList);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style>
</style>